import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InterventionTeamResource} from "./intervention-team.resource";
import {DropdownSelectionModule} from "../../common/components/dropdown-selection/dropdown-selection.module";
import {provideRouter, RouterModule, withComponentInputBinding} from "@angular/router";
import {InterventionTeamManagerModule} from "./teams/intervention-team-manager/intervention-team-manager.module";
import {InterventionTeamsNavigationModule} from "./navigation/intervention-teams-navigation.module";
import {routes} from "./intervention-team.routes";
import {ContactsManagerModule} from "./contacts/contacts-manager/contacts-manager.module";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DropdownSelectionModule,
    InterventionTeamManagerModule,
    InterventionTeamsNavigationModule,
    ContactsManagerModule,
    // RouterModule.forChild(routes),
  ],
  providers: [
    InterventionTeamResource,
    provideRouter(routes, withComponentInputBinding()),
  ]
})
export class InterventionTeamsModule {
}
